/* eslint-disable react/prop-types */
import React from 'react';

// Centered value + label stat box used in the lightning panels.
//  • size="lg" → radar-hub lightning panel (larger)
//  • size="sm" → compact lightning tile (mini grid)
const StatTile = ({ value, unit, label, valueColor, size = 'lg' }) => {
  const lg = size === 'lg';
  return (
    <div className={lg ? 'lightning-stat' : 'lightning-mini-stat'}>
      <div
        className={lg ? 'lightning-stat-value' : 'lms-val'}
        style={valueColor ? { color: valueColor } : undefined}
      >
        {value}
        {unit ? (
          lg ? (
            <span className="unit"> {unit}</span>
          ) : (
            <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>
              {' '}
              {unit}
            </span>
          )
        ) : null}
      </div>
      <div className={lg ? 'lightning-stat-label' : 'lms-label'}>{label}</div>
    </div>
  );
};

export default StatTile;
